/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifySms} from '../api'

export const useMutationVerifySms = createReactQueryMutationHook('verifySms', verifySms)
